import {
  ButtonBase,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core'
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons'

import React from 'react'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import { TruncatedId } from '../../truncated-id'
import { useListNotificationSegments } from '../hooks/useListNotificationSegments'

interface ISegmentSelector {
  disabled?: boolean
  segments: string[]
  setSegments: (segment: string[]) => void
}

export const SegmentSelector = (props: ISegmentSelector) => {
  const { data, loading } = useListNotificationSegments({
    input: {
      limit: 100
    }
  })

  return loading ? (
    <CircularProgress />
  ) : (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {(data?.listNotificationSegments?.notificationSegments || []).map(segment => (
              <TableRow key={segment.id}>
                <TableCell>
                  {props.segments.includes(segment.id) ? (
                    <ButtonBase
                      disabled={props.disabled}
                      onClick={() => {
                        if (props.disabled) {
                          return
                        }

                        props.setSegments(props.segments.filter(s => s !== segment.id))
                      }}>
                      <RadioButtonChecked />
                    </ButtonBase>
                  ) : (
                    <ButtonBase
                      disabled={props.disabled}
                      onClick={() => props.setSegments([...props.segments, segment.id])}>
                      <RadioButtonUnchecked />
                    </ButtonBase>
                  )}
                </TableCell>
                <TableCell>
                  <TruncatedId value={segment.id} full path={`/notifications/segments/${segment.id}`} />
                </TableCell>
                <TableCell>{segment.title}</TableCell>
                <TableCell>{segment.isDynamic ? <SyncAltIcon /> : null}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
